import React, { DetailedHTMLProps, ForwardedRef, InputHTMLAttributes, useState } from "react";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";

import { Input } from "../Input/Input";

type TProps = DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> & {
  label: string;
  error?: string;
  autoFocus?: boolean;
};

export const PasswordInput = React.forwardRef((props: TProps, ref: ForwardedRef<HTMLInputElement>) => {
  const [passwordVisible, setPasswordVisible] = useState(false);
  const passwordEyeIcon = passwordVisible ? (
    <VisibilityOffOutlinedIcon sx={{ cursor: "pointer" }} fontSize="small" onClick={() => setPasswordVisible(false)} />
  ) : (
    <VisibilityOutlinedIcon sx={{ cursor: "pointer" }} fontSize="small" onClick={() => setPasswordVisible(true)} />
  );

  return <Input {...props} type={passwordVisible ? "text" : "password"} ref={ref} icon={passwordEyeIcon} />;
});
